import React from 'react';
import PropTypes from 'prop-types';

class Video extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const style = this.props.height ? { height: this.props.height } : {};

    return (
      <div className="video-container">
        <video style={style} className={this.props.className} autoPlay muted={this.props.muted} loop webkit-playsinline="true" playsInline>
          { Object.entries(this.props.sources).map(([format, src]) => {
            return <source key={format} src={src} type={`video/${format}`} />;
          })};
        </video>
      </div>
    );
  }
}

Video.defaultProps = {
  className: '',
  muted: true
};

Video.propTypes = {
  height: PropTypes.number,
  className: PropTypes.string,
  sources: PropTypes.objectOf(PropTypes.string).isRequired,
  muted: PropTypes.bool
};

export default Video;
